import React, { forwardRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import Image from "../Image";
import classNames from "classnames";

export interface IBlogBodyProps extends IEditableProps, IStyledProps {
    src?: string;
    alt?: string;
    children;
}

const BlogBody = forwardRef((props: IBlogBodyProps, ref: any) => {
    const { className, children, editorClassObj, cmsId, src, alt } = props;

    return (
        <div data-id={cmsId} ref={ref} className={classNames("container content border-0 blog-body position-relative", className, editorClassObj)}>
            <Image dataTestId="blog-body-image" src={src} alt={alt} className="blog-body-image position-absolute d-none d-lg-block"/>
            <div className="container content no-border">
                <div className="row">
                    <div className="col-lg-7 mx-auto px-xl-6 px-lg-5 px-4 col-lg">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default styled(BlogBody)`
    .no-border{
        border-top: none !important;
    }

    .blog-body-image {
        position: absolute;
        top: 200px;
        right: 0px;
        img {
            height: 450px;
            max-width: 125px;
            object-fit: cover;
        }
    }

    blockquote {
        font-style: italic;
        color: #757575;
        padding: 1rem 0rem 1rem 1rem;
        position: relative;
    }

    blockquote h6 {
        font-style: normal;
    }

    blockquote .quotation {
        font-size: 7rem;
        line-height: 7rem;
        font-style: normal;
        display: inline;
        float: left;
        -webkit-text-stroke: 1.5px #F4AF23;
        font-weight: 400;
        color: transparent;
        position: relative;
        top: -7px;
        right: 13px;
    }
`;